import type { ComparisonOffer } from '@entities/mto';

/** Цена предложения как в документе + валюта, если она указана. */
export function offerPrice(offer: Pick<ComparisonOffer, 'price' | 'currency'>): string {
  if (!offer.price) return '—';
  return offer.currency ? `${offer.price} ${offer.currency}` : offer.price;
}

/** Почему предложение не участвует в сравнении — подсказка к приглушённой
 *  строке. Без неё «бледная» строка выглядит как сбой витрины. */
export function incomparableHint(offer: ComparisonOffer, compareCurrency: string | null): string {
  if (offer.price_value === null) return 'цена не распознана';
  // Рубль не помечается: `null` и у базы «рубли», и у рублёвого предложения.
  // Рублёвое при базе в юанях выпадает из сравнения именно из-за валюты, и
  // писать «другая единица» было бы неправдой.
  if ((offer.currency ?? null) !== compareCurrency) {
    return `другая валюта (${offer.currency ?? 'руб.'})`;
  }
  return 'другая единица измерения';
}
